import React from 'react';
import PropTypes from 'prop-types';

import { csrfToken } from 'utils/networking-client';

// Note:
// After POSTing the form, we redirect the athlete to PayPal's URI where
// they enter their PayPal info. PayPal then redirects them back to our app.
// Because this legacy PayPal flow and the SummitPayPalController use plain
// old redirects, we can use a plain old HTML form to POST without any need
// for redux or component instance methods.

const PayPalCheckout = ({ sku, promotionCode }) => (
  <form action="/paypal/summit_checkout" method="post">
    <input
      type="image"
      src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-large.png"
      alt="Check out with PayPal"
      style={{ width: '208px' }}
    />
    <input type="hidden" name="sku" value={sku} />
    <input type="hidden" name="authenticity_token" value={csrfToken()} />
    {promotionCode && <input type="hidden" name="code" value={promotionCode} />}
  </form>
);

PayPalCheckout.propTypes = {
  sku: PropTypes.string.isRequired,
  promotionCode: PropTypes.string
};

PayPalCheckout.defaultProps = {
  promotionCode: ''
};

export default PayPalCheckout;
